import React, { useEffect, useState } from 'react';
import CommonLayout from '../../layouts/CommonLayout';
import AnnouncementContainer from '../../containers/AnnouncementContainer';
import { getAnnouncementList } from '../../../api/AnnouncementApi';
import { useNavigate } from 'react-router-dom';

const AnnouncementListPage = () => {
  const [announcements, setAnnouncements] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    getAnnouncementList()
      .then((data) => {
        setAnnouncements(data.announcementListDtoList || []);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  return (
    <CommonLayout title="공지사항">
      <div className="p-4 max-w-lg mx-auto">
        {announcements.length === 0 ? (
          <div className="text-center text-gray-500 mt-20">공지사항이 없습니다.</div>
        ) : (
          <div className="divide-y">
            {announcements.map((item) => (
              <AnnouncementContainer
                key={item.id}
                title={item.title}
                createdAt={item.createdAt}
                onClick={() => navigate(`/app/mypage/announcements/${item.id}`)}
              />
            ))}
          </div>
        )}
      </div>
    </CommonLayout>
  );
};

export default AnnouncementListPage;
